export default __webpack_public_path__ + "static/media/Vaq_Declaration.13b9492d.pdf";